import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { App } from "../App";
import { DEXTokenTierView } from "../api/classes/models";
import { PulseChain } from "../contracts/PulseChain";

export class CmpSelectERC20 extends com.CmpSelectERC20Base {

    private static readonly TAKE = 10;

    private _onChangeValue:gs.EventGS<DEXTokenTierView|undefined>;
    private _onChangeValueToken:gs.EventGSToken<DEXTokenTierView|undefined>;
    private _rows:{item:com.CmpTableItemERC20; token:DEXTokenTierView|undefined}[] = [];
    private _selectedToken:DEXTokenTierView|undefined;
    private _searchVersion:number = 0;

    constructor() {
        super();
        this._onChangeValueToken = new gs.EventGSToken<DEXTokenTierView|undefined>();
        this._onChangeValue = new gs.EventGS(this._onChangeValueToken);

        this.ctrls.cmpSearch.ctrls.iSearch.el.oninput=async ()=>{
            const value = this.ctrls.cmpSearch.ctrls.iSearch.value.trim();
            if (this._selectedToken !== undefined)
            {
                this._selectedToken = undefined;
                this._onChangeValueToken.invoke(undefined);
            }
            if (value.length>=2 || value=="")
            {
                await this._searchERC20sAsync(value);
                return;
            }

            this._searchVersion++;
            this._clearRows();
        }

        void this._searchERC20sAsync("");
    }

    public get onChangeValue() {return this._onChangeValue;}

    public get selectedToken() {return this._selectedToken;}

    private _clearRows()
    {
        for(const row of this._rows) row.item.cut();
        this._rows = [];
    }

    private _selectToken(row:{item:com.CmpTableItemERC20; token:DEXTokenTierView})
    {
        for(const currentRow of this._rows) currentRow.item.inactive();
        row.item.active();
        this._selectedToken = row.token;
        this._onChangeValueToken.invoke(row.token);
    }

    private async _searchERC20sAsync(searchQuery:string)
    {
        if (!searchQuery) {this._emptyTable(); return;}
        const searchVersion = ++this._searchVersion;
        this.ctrls.cmpSearch.ctrls.iSearch.value=searchQuery;
        this._clearRows();

        const tokens = await App.api.dEXWatcher.getTokensByTier(0, CmpSelectERC20.TAKE, searchQuery);
        if (searchVersion != this._searchVersion) return;
        if (!tokens) return;

        for(const token of tokens)
        {
            const item = new com.CmpTableItemERC20();
            //const shortAdr = token.address.substring(0,12)+".."+token.address.substring(token.address.length-10,token.address.length)
            item.ctrls.lSymbol.text = PulseChain.GetSymbolOrDef(token.address, token.symbol) || "-";
            item.ctrls.lAdrs.text = token.address || "-";
            if (token.address) item.ctrls.lAdrs.attr("title", token.address);
            this.append(item);

            const row = { item, token };
            this._rows.push(row);
            item.onclick=()=>this._selectToken(row);

            if (this._selectedToken?.address?.toLowerCase() == token.address?.toLowerCase())
                item.active();
        }
    }

    private _emptyTable()
    {
        this._clearRows();
        for(let i=0;i<10;i++)
        {
            const item = new com.CmpTableItemERC20();
            const token = undefined;
            item.ctrls.lSymbol.text = "-";
            item.ctrls.lAdrs.text = '';
            this.append(item);
            const row = { item, token };
            this._rows.push(row);
        }
    }
}
